import { type Editor, EditorProvider, type AnyExtension } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

interface Props {
  initialContent?: string;
  /**
   * Extensions to add to the editor. https://tiptap.dev/docs/editor/core-concepts/extensions
   */
  extensions?: AnyExtension[];
  onBlur?: () => void;
  onUpdate?: ({ editor }: { editor: Editor }) => void;
  onFocus?: () => void;
  /**
   * Class to apply to the editor element
   */
  editorClass?: string;
  slotBefore?: React.ReactNode;
  slotAfter?: React.ReactNode;
}

export const RichTextEditorProvider = ({
  initialContent,
  extensions,
  onBlur,
  onUpdate,
  onFocus,
  editorClass,
  slotBefore,
  slotAfter,
}: Props) => {
  const providerProps = {
    extensions: [StarterKit, ...(extensions || [])],
    onBlur,
    onUpdate,
    onFocus,
    editorProps: editorClass
      ? {
          attributes: {
            class: editorClass,
          },
        }
      : {},
    content: initialContent,
    slotBefore,
    slotAfter,
  };

  return <EditorProvider {...providerProps} />;
};
